import React               from "react";
import {Grid, makeStyles}                 from '@material-ui/core';

const useStyles = makeStyles(theme =>({
  questionContainer:{
    width: "100%",
    height:"100%",
  },
  reading: {
    width: "80%",
    margin:"10px 0 10px 0 ",
    font: '22px lato',
    letterSpacing: '0.21px',
    [theme.breakpoints.down(1400)]:{
      font: " 18px lato",
      width: "95%",
    },
    [theme.breakpoints.down(1310)]:{
      font: "500 16px lato",

    },
    [theme.breakpoints.down(925)]:{
      font: "500 14px lato",

    },
    [theme.breakpoints.down(426)]:{
      font: "500 12px lato",
 
    }, 
  },
  table: {
    width: "100%",
    font: '22px lato',
    [theme.breakpoints.down(1400)]:{
      font: " 18px lato",
      width: "95%",
    },
    [theme.breakpoints.down(1310)]:{
      font: "500 16px lato",
 
    },
    [theme.breakpoints.down(925)]:{
      font: "500 14px lato",

    },
    [theme.breakpoints.down(426)]:{
      font: "500 12px lato",

    }, 
  },
  tdTable: {
    padding: "0 1%",
    border: '1px solid black',
    textAlign: 'left'
  }
}));

const QuestionTable = (props) => {
  const classes = useStyles()

  return(
    <Grid container className={classes.questionContainer}>
      <p
        className={classes.reading}
      >
        4.Clasifica los siguientes ejemplos como ventaja o desventaja.
      </p>
      <br/>
      <table className={classes.table}>
        <thead>
          <th style={{width: "40%",border: '1px solid black', textAlign: 'center'}}><i>Valoración</i></th>
          <th style={{width: "60%",border: '1px solid black', textAlign: 'center'}}><i>Ejemplos</i></th>
        </thead>
        <tbody>
          <tr>
            <td className={classes.tdTable}>
              <p>
              Ventaja
              </p>
            </td>
            <td className={classes.tdTable}>
              <p className={classes.tdTable}>
              a. interacción humana reducida
              </p>
              <p className={classes.tdTable}>
              b. materiales educativos
              </p>
            </td>
          </tr>
          <tr>
            <td className={classes.tdTable}>
              <p>
              Desventaja
              </p>
            </td>
            <td className={classes.tdTable}>
              <p className={classes.tdTable}>
              c. comunicación inmediata
              </p>
              <p className={classes.tdTable}>
              d. ejercicio físico limitado
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </Grid>
  )
}

export default QuestionTable;
